import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../base/hooks';
import { VacancyTableFilter } from '../enums';
import { vacancyActions } from '../redux/slices/vacancySlice';
import { VacancyConfirmation } from './VacancyConfirmation';
import { VacancyForm } from './VacancyForm';
import { VacancyTable } from './VacancyTable';
import { VacancyView } from './VacancyView';

export const Vacancy = () => {
    const dispatch = useAppDispatch();
    const { initialized } = useAppSelector((state) => state.vacancy);

    useEffect(() => {
        dispatch(vacancyActions.init());
    }, []);

    if (!initialized) {
        return null;
    }

    return (
        <Routes>
            <Route index element={<Navigate to='active' replace />} />
            <Route path='active' element={<VacancyTable filter={VacancyTableFilter.Active} />} />
            <Route path='draft' element={<VacancyTable filter={VacancyTableFilter.Draft} />} />
            <Route path='archived' element={<VacancyTable filter={VacancyTableFilter.Closed} />} />
            <Route path='create' element={<VacancyForm />} />
            <Route path='duplicate/:id' element={<VacancyForm duplicate />} />
            <Route path='update/:id' element={<VacancyForm />} />
            <Route path='view/:id' element={<VacancyView />} />
            <Route path='confirmation/:id' element={<VacancyConfirmation />} />
        </Routes>
    );
};
